import { hasTruncatedTextFromLineClamp } from "../../../../javascript/utils";

interface Props {
  containerElement: Element
}

const hideOrShowReadMoreButton = async (bodyElement: Element, readMoreElement: Element) => {
  if (!bodyElement) return;
  if (!readMoreElement) return;

  if (hasTruncatedTextFromLineClamp(bodyElement)) {
    readMoreElement.classList.add('display-block');
  } else {
    readMoreElement.classList.remove('display-block');
  }
}

const addEventListeners = (bodyElement: Element, readMoreElement: Element) => {
  readMoreElement.addEventListener('click', () => {
    bodyElement.classList.add('body-with-read-more-body-expanded');
    readMoreElement.remove();
  })

  window.addEventListener('resize', () => {
    hideOrShowReadMoreButton(bodyElement, readMoreElement);
  });
}

const init = (props: Props) => {
  const bodyElement = props.containerElement.querySelector('.body-with-read-more-body');
  const readMoreElement = props.containerElement.querySelector('.body-with-read-more-shortened-body-text');

  addEventListeners(bodyElement, readMoreElement);
  hideOrShowReadMoreButton(bodyElement, readMoreElement);
}

export const BodyWithReadMore = {
  init,
};
